/**
 * Cookie-based secure storage for refresh tokens (browser web app).
 * Access tokens remain in Zustand only — never localStorage or sessionStorage.
 */

function setCookie(name: string, value: string, days: number) {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/;SameSite=Strict`;
}

function getCookie(name: string): string | null {
  const match = document.cookie
    .split(';')
    .map(c => c.trim())
    .find(c => c.startsWith(`${name}=`));
  if (!match) return null;
  return decodeURIComponent(match.split('=')[1]);
}

function deleteCookie(name: string) {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;SameSite=Strict`;
}

export async function setSecureItem(key: string, value: string): Promise<void> {
  setCookie(key, value, 7); // 7 days matches refresh token expiry
}

export async function getSecureItem(key: string): Promise<string | null> {
  return getCookie(key);
}

export async function removeSecureItem(key: string): Promise<void> {
  deleteCookie(key);
}

export { removeSecureItem as deleteSecureItem };